// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import DarkLightIcon from "../icons-svg/DarkLightIcon";
// import { themeMode, toggleMode } from "../features/theme/themeSlice";

// const DarkLightMode = () => {
//   const { mode } = useSelector((state) => state.theme);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     document.documentElement.className = mode;
//     localStorage.setItem("thememode", mode);
//   }, [mode]);

//   const onModeClick = (e) => {
//     e.stopPropagation();
//     dispatch(toggleMode());
//   };

//   return (
//     <button
//       className="cursor-pointer py-1 px-1 flex text-lg rounded-full focus:outline-none"
//       onClick={onModeClick}
//     >
//       {mode === themeMode.DARK ? (
//         <DarkLightIcon className="dark w-4 h-4 text-white" />
//       ) : (
//         <DarkLightIcon className="light w-4 h-4 text-black rotate-180 sm:px-5 mt-5" />
//       )}
//     </button>
//   );
// };

// export default DarkLightMode;

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DarkLightIcon from "../icons-svg/DarkLightIcon";
import { themeMode, toggleMode } from "../features/theme/themeSlice";

const DarkLightMode = () => {
  const { mode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();

  useEffect(() => {
    const root = document.documentElement;
    if (mode === themeMode.DARK) {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("thememode", mode);
  }, [mode]);

  const onModeClick = (e) => {
    e.stopPropagation();
    dispatch(toggleMode());
  };

  return (
    <button
      type="button"
      onClick={onModeClick}
      aria-label={mode === themeMode.DARK ? "Switch to light mode" : "Switch to dark mode"}
      title={mode === themeMode.DARK ? "Light" : "Dark"}
      className="cursor-pointer py-1 px-1 flex items-center justify-center text-lg rounded-full
                 focus:outline-none focus:ring-0 transition-colors"
    >
      {mode === themeMode.DARK ? (
        <DarkLightIcon className="w-4 h-4 text-gray-200" />
      ) : (
        <DarkLightIcon className="w-4 h-4 text-gray-900" />
      )}
    </button>
  );
};

export default DarkLightMode;
